import React from "react";

import Editor from '../../widgets/editor/editor';

export default class ProductDetails extends React.Component {
  render() {
    const editorStyle = {
      'width': '600px',
      'marginLeft': 'auto',
      'marginRight': 'auto',
    }
    return (
      <div style={editorStyle}>
        <h3>行程介绍：</h3>
        <Editor />
        <h3>预订须知：</h3>
      </div>
    );
  }
}
